import { useOrderStore } from '../../../../store/useOrder';
import { formatDate } from '../../../../util/util';

/**
 * @author taulmax
 * @date 2024.11.06
 * @description 주문 목록 상세 페이지 - 작성 정보
 */
const ODWriteInfo = () => {
  const { orderDetail } = useOrderStore();

  return (
    <div className="!space-y-3">
      {orderDetail ? (
        <>
          <div>
            <p className="!text-xs !text-gray-500">생성일</p>
            <p className="!text-sm !font-medium !text-gray-900 !mt-0.5 !break-all">
              {formatDate(orderDetail.createdAt).timestamp}
            </p>
          </div>
          
          <div>
            <p className="!text-xs !text-gray-500">수정일</p>
            <p className="!text-sm !font-medium !text-gray-900 !mt-0.5 !break-all">
              {formatDate(orderDetail.updatedAt).timestamp}
            </p>
          </div>
          
          <div className="!flex !items-center !justify-between">
            <div className="!flex-1 !mr-4">
              <p className="!text-xs !text-gray-500">생성자/수정자</p>
              <p className="!text-sm !font-medium !text-gray-900 !mt-0.5">
                {orderDetail.createdBy} / {orderDetail.updatedBy}
              </p>
            </div>
            
            <div>
              <span className={`!inline-flex !items-center !px-2.5 !py-1 !text-xs !font-medium !rounded-md ${
                orderDetail.realtimeYn === 'Y' 
                  ? '!bg-green-50 !text-green-700 !ring-1 !ring-inset !ring-green-600/20' 
                  : '!bg-gray-50 !text-gray-700 !ring-1 !ring-inset !ring-gray-600/20'
              }`}>
                <div className={`!w-1.5 !h-1.5 !rounded-full !mr-1.5 ${
                  orderDetail.realtimeYn === 'Y' ? '!bg-green-600' : '!bg-gray-600'
                }`}></div>
                {orderDetail.realtimeYn === 'Y' ? '실시간' : '비실시간'}
              </span>
            </div>
          </div>
        </>
      ) : (
        <div className="!space-y-3">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="!h-10 !bg-gray-100 !rounded-lg !animate-pulse"></div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ODWriteInfo;
